export const appendUrlParam = (currentLink, urlParam) => {
  const separator = currentLink.includes('?') ? '&' : '?';
  return urlParam ? `${currentLink}${separator}${urlParam}` : currentLink;
};